import React from "react";
import { ClockIcon, FlameIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  showBadge?: boolean;
};
export function Countdown({
  showBadge = true
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-18" data-mp="3c12xquarbjgg">
      <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-brand-700 sm:text-sm" data-id="element-19" data-mp="3h18uupzspy5x">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="324zxxv3dnwwo" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-21" data-mp="373b9qbd8ghhj">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-22" data-mp="10dmu79d5bv27" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-23" data-mp="15bg1k5q6qv42">
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-brand-800 font-serif text-3xl font-bold tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-24" data-mp="15awiumspo2oz">
                {u.value}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted" data-id="element-25" data-mp="t095344j7nsd">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-4 font-serif text-2xl font-bold text-brand-700 sm:pt-5 sm:text-3xl" aria-hidden="true" data-id="element-26" data-mp="12seuc63efr3v">
                :
              </span>}
          </React.Fragment>)}
      </div>
      {showBadge && <p className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-bad-light px-3 py-1 text-xs font-bold uppercase text-bad sm:text-sm" data-id="element-27" data-mp="o2qtt731kwh7">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-28" data-mp="k0lym3wy3rsg" />
          Limited launch price
        </p>}
    </div>;
}